// Tarefa de quem saiu da empresa fica arquivada: fora da lista, do Kanban, do
// calendário, dos painéis de Tarefas e do card "Tarefas Pendentes" da home,
// mesmo com "Todos os responsáveis" selecionado. Nada é apagado — a tarefa
// continua no banco e volta a aparecer se o usuário for reativado ou se ela
// for transferida para alguém ativo.
//
// "Saiu da empresa" = responsável com `profiles.status = 'inactive'` ou que
// nem existe mais em `profiles` (usuário excluído — `tarefas.responsavel_id`
// não tem FK, então a tarefa sobrevive à exclusão do perfil).
//
// Solicitação (Central de Solicitações) fica de fora da regra: é fila
// compartilhada, e um chamado parado com quem saiu precisa ser redirecionado,
// não escondido.

export interface PerfilComStatus {
  id: string | number;
  status?: string | null;
}

export interface TarefaComResponsavel {
  responsavel_id?: string | number | null;
  categoria?: string | null;
}

/**
 * Monta a checagem a partir da lista de perfis já carregada pela tela.
 *
 * Lista vazia (perfis ainda carregando ou a consulta falhou) não arquiva nada:
 * sem ela todo responsável pareceria "excluído" e a tela inteira sumiria.
 */
export function criarChecagemTarefaArquivada(
  perfis: PerfilComStatus[] | null | undefined,
): (tarefa: TarefaComResponsavel) => boolean {
  if (!perfis || perfis.length === 0) return () => false;

  const ativos = new Set<string>();
  for (const p of perfis) {
    if (p.status !== 'inactive') ativos.add(String(p.id));
  }

  return (tarefa) => {
    if (tarefa.categoria === 'solicitacao') return false;
    if (tarefa.responsavel_id == null || tarefa.responsavel_id === '') return false;
    return !ativos.has(String(tarefa.responsavel_id));
  };
}
